/**
 * https://www.pdftron.com/api/web/Core.AnnotationManager.html#getAnnotationById__anchor
 */
export default Id => window.documentViewer.getAnnotationManager().getAnnotationById(Id);
